/* unplugin-vue-components disabled */import script from "./BottomNav.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomNav.vue?vue&type=script&setup=true&lang=js"

import "./BottomNav.vue?vue&type=style&index=0&id=9d9eb466&lang=scss"

const __exports__ = script;

export default __exports__